import LazyLoad from 'vanilla-lazyload';
import lottie from 'lottie-web';

// Initialize lazy loading
new LazyLoad();

// Navigation
const button = document.querySelector('.hamburger');
const menu = document.querySelector('#main-navigation');

// eslint-disable-next-line no-undef
const themeDir = theme_directory;

button.addEventListener('click', () => {
  button.classList.toggle('is-active');
  menu.classList.toggle('hidden');
});
const element = document.getElementById('lottie');

lottie.loadAnimation({
  container: element, // the dom element that will contain the animation
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path: `${themeDir}/public/images/Sync_Saved_Locally_lottie.json`, // the path to the animation json
});

const form = document.querySelector('#contact-form');

if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    form.reset();
  });
}
